const history = {
  title: 'مشروعاتي',
  upgradeBtn: 'ترقية',
  subTitle: 'لا تنس تحميل ملفك لأنه سيُحذف بعد 72 ساعة.',
  MAgo: 'منذ {{num}} دقائق',
  HAgo: 'منذ {{num}} ساعات',
  DAgo: 'منذ {{num}} ساعات',
  justNow: 'الآن',
  originalFile: 'الملف الأصلي',
  selectAllBtn: 'اختيار الكل',
  emptyTips: 'لا يوجد أي مشروعات بعد. <1>اذهب للتعديل </1>',
  deleteTips: 'هل أنت متأكد أنك تريد حذف ذلك؟',
};

export default history;
